import { useCallback, useEffect, useMemo, useState } from 'react';
import { UserInfo, UserService } from '../service/user-service';
import useUserContext from './useUserContext';
import useErrorStateContext from './useErrorStateContext';
import useLanguageSelector from './useLanguageSelector';

export const useUser = () => {
  const LANG = useLanguageSelector();

  const [userInfo, setUerInfo] = useState<UserInfo | null>(null);
  const userService = useMemo(() => new UserService(), []);
  const { updateUserInfo } = useUserContext();
  const errorCtx = useErrorStateContext();
  const userErrorMessage = LANG.KT_9000_02;

  const getUerInfo = async () => {
    const result = await userService.fetchLoginUserInfo();
    if (!result) {
      errorCtx.setErrorState({
        error: new Error(),
        message: userErrorMessage
      });
      return;
    }
    setUerInfo((prev) => {
      if (prev) {
        return {
          ...prev,
          ...{
            nickName: result.nickName,
            userId: result.userId,
            role: result.role
          }
        };
      } else {
        return {
          ...{
            nickName: result.nickName,
            userId: result.userId,
            role: result.role
          }
        };
      }
    });
    updateUserInfo(result);
  };
  useEffect(() => {
    getUerInfo();
  }, []);
  return { userInfo };
};
